import { formatTLTickerMatchups as formatTLTickerMatchupsShared } from '@pickleballinc/ui/lib/formatTLTickerMatchups';

import { publicEnv } from '@/lib/env';
import type { Matchup, TeamLeagueMatchup } from '@/modules/ticker/types';
import { MLP_TL_SLUG, TEAM_LEAGUES_PLACEHOLDER_IMAGE } from '@/utils/helpers/constants';

// Thin wrapper: injects pickleball env/constants into the shared formatter.
// The homepage ticker always shows MLP, so the slug is fixed.
export function formatTLTickerMatchups({
  matchupsInfos,
}: {
  matchupsInfos: TeamLeagueMatchup[];
}): Matchup[] {
  return formatTLTickerMatchupsShared({
    matchupsInfos,
    teamLeagueSlug: MLP_TL_SLUG,
    ptlUrl: publicEnv.NEXT_PUBLIC_PTL_URL,
    placeholderImage: TEAM_LEAGUES_PLACEHOLDER_IMAGE,
  });
}
